import { InjectionToken } from '@angular/core';

export interface CarePlanNavi {
  sendMessageToSelectedConversation(
    content: string,
    clientGuid?: string,
  ): Promise<boolean>;
}

/** App-owned bridge from Care Plan qualification flows into the active Navi chat. */
export const CARE_PLAN_NAVI = new InjectionToken<CarePlanNavi>(
  'CARE_PLAN_NAVI',
);
